import  React, {
  // useContext,
  useState,
  useEffect
} from 'react'
import { GestionListas } from '@portal/arq-portal-gestion-listas';
import { 
  api,
   getAplicacionFromUrl,
   getCiaFromUrl,
  //  PortalContext, 
   PortalSplash} from '@portal/arq-portal-core';
import { Button, makeStyles,
   } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  guardar: {
    display: 'flex',
    justifyContent:'flex-end'
  },
  boton: {
    color: "#fff",
    width: "150px",
    // border: "2px solid #f2f2f2",
    padding: "4px 16px",
    background: "#606060",
    boxShadow: "none !important",
    fontWeight: "bold",
    borderRadius: 0,
  },
  fichaAutos: {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    color: '#606060',
    fontFamily: 'CO-Bold',
    '& h3': {
        fontSize: '18px',
        marginBottom: '10px',
        paddingBottom: '15px',
        borderBottom: '1px solid #919191'
    }
  },
  wrapperFicha:{
    '@media screen and (min-width: 992px)': {
      // width:'50%',
    },
    padding: '1.5rem', 

  },
}));

export const AdmBloqueadosMicrostrategy = (props:any) => {
  const [bloqueadosFijos, setBloqueadosFijos] = useState<any[]>([]);
  const [bloqueados, setBloqueados] = useState<any[]>([]);
  const [visibles, setVisibles] = useState<any[]>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [mensaje, setMensaje] = useState<any>(null);

  const classes = useStyles(props);
  const myRef = React.useRef(null);
  let puntosAplicacionesMicrostrategy : any[] = [];

  useEffect(() => {
    if(!isLoaded){
      const cia = getCiaFromUrl();
      const aplicacion = getAplicacionFromUrl();
      api.post("/usermenu/getpuntosmicrostrategy",{ app: aplicacion + cia }).then((rpta) => {
        // Desde BE el listado de los puntos de tipo microstrategy completos, independiente de si son o no visibles al usuario 
        puntosAplicacionesMicrostrategy = rpta.puntosmicrostrategy;
        
        api.post("/be/recuperarbloqueadoscachepuntosmicrostrategy",{Entrada: {}})
            .then(x => {
                if(x?.Salida?.listaPuntos != null){
                  let bloqueadosFlexibles: any[]=[];
                  let listavisibles: any[]=[];
                  let mybloqueadosFijos = x?.Salida?.listaPuntos? x.Salida.listaPuntos : [];
                  puntosAplicacionesMicrostrategy.forEach((puntomenu: any)=>{
                  let index = mybloqueadosFijos.findIndex((x: any) => x == puntomenu.id);
                  if(index > -1){
                    bloqueadosFlexibles.push({id: puntomenu.id, titulo: puntomenu.titulo, fijo: false})
                    mybloqueadosFijos.splice(index, 1);
                  }else{
                    listavisibles.push({id: puntomenu.id, titulo: puntomenu.titulo, fijo: false})
                  }
                  })      
                  setVisibles(listavisibles);
                  setBloqueados(bloqueadosFlexibles);
                  setBloqueadosFijos(mybloqueadosFijos??[]);
                }
                setIsLoaded(true);
              }).catch((error) => {
                console.log(error);
                setMensaje({
                  titulo: "Ha surgido un error al obtener los datos",
                  subtitulo: "Si continua ponte en contacto con soporte",
                  tipo: "error"
                })
              });;
        }).catch((error) => {
          console.log(error);
          setMensaje({
            titulo: "Ha surgido un error al obtener los datos",
            subtitulo: "Si continua ponte en contacto con soporte",
            tipo: "error"
          })
        });
    }
  },[isLoaded]);

  const handleGuardar = async ()=>{
    setIsSaving(true);
    // @ts-ignore
    let bloqueados = myRef.current.getSave().map((x)=>{return x.id})
    bloqueados = (bloqueados && bloqueados.length)? bloqueados.concat(bloqueadosFijos??[]) : bloqueadosFijos??[]
    api.post("/be/guardarbloqueadoscachepuntosmicrostrategy",{Entrada: { listadoPuntosNuevos: bloqueados }})
    .finally(()=> {setIsLoaded(false); setIsSaving(false)});
  }
  return <React.Fragment>
          {(!isLoaded || isSaving) && <PortalSplash titulo={isSaving? "Guardando nueva configuración" :"Administración Microstrategy : puntos de menu bloqueados"} mensaje={mensaje}></PortalSplash>}
          {(isLoaded && !isSaving) && <div className = {classes.wrapperFicha}> 
            <div className={classes.fichaAutos}>
              <h3> Administración Microstrategy : puntos de menu bloqueados</h3>
              <div>
                  <GestionListas ref={myRef} disponibles={visibles} seleccionados={bloqueados}/>
                  <div className={classes.guardar}>
                    <Button variant="text" className={classes.boton} onClick={handleGuardar}>Guardar</Button>
                  </div>
              </div>
            </div>
          </div>}
        </React.Fragment>
}
